// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"b911c649","498":"14e8f96c","513":"34ec7c63","703":"05163245"}[chunkId] + ".chunk.js";
};